<app-main-nav></app-main-nav>
<div class="container notfound">
    <div>
        <img src="./assets/img/notfound_bg.svg" height="400" />
        <h4>Opps, it seems that the you're looking for does not exists</h4>
    </div>
</div>
<router-outlet></router-outlet>